export default "__VITE_ASSET__DMCjXwYR__"